import { useState } from "react";

import { Button } from "@icg360/design-system";

import SagesureLogo from "images/sagesure-logo.svg?react";

import { PublicMobileNav } from "./mobile-nav";
import { PublicHeaderNav } from "./nav";
import styles from "./public-header.module.scss";

type PublicHeaderProps = {
  hideNav?: boolean;
  className?: string;
};

export const PublicHeader = ({
  hideNav = false,
  className = "",
}: PublicHeaderProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <header className={[styles.header, className].join(" ")}>
        <div className={styles.container}>
          <div>
            <a className={styles.logoLink} title="SageSure Logo" href="/">
              <SagesureLogo className={styles.logo} />
            </a>
          </div>
          <div className={styles.contentSlot}>
            {!hideNav && (
              <>
                <div className={styles.mobileNavButton}>
                  <Button
                    appearance="tertiary"
                    onPress={() => {
                      setMenuOpen(!menuOpen);
                    }}
                    className={styles.headerButton}
                    icon={menuOpen ? "Close" : "Menu"}
                    data-testid="unauth-menu-toggle-btn"
                  />
                </div>
                <PublicHeaderNav />
              </>
            )}
          </div>
        </div>
      </header>
      <div className={styles.mobileSlot}>
        {!hideNav && (
          <PublicMobileNav menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        )}
      </div>
    </>
  );
};
